define.alias("shared/helpers/profile-color-class", "preview-grid/helpers/profile-color-class");